/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WarningTriangleIcon16Light = forwardRef('WarningTriangleIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M8.25 10.5a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0Z" }),
        React.createElement("path", { d: "M8 4.5a.5.5 0 1 0-1 0v3.4a.5.5 0 0 0 1 0V4.5Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.783 1.481c.776-1.298 2.658-1.298 3.434 0l5.08 8.502c.797 1.333-.163 3.026-1.716 3.026H2.419c-1.553 0-2.514-1.693-1.717-3.026l5.081-8.502Zm2.575.513a1 1 0 0 0-1.716 0L1.56 10.496a1 1 0 0 0 .859 1.513H12.58a1 1 0 0 0 .858-1.513L8.36 1.994Z" })));
});
